export const config = {
  isAnimate: true,
};
